// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v4-main {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: #ffffff;
}
@media (max-width: 768px) {
  .v4-main.responsive {
    flex-direction: column;
  }
  .v4-main.responsive .login-left {
    clip-path: none;
    height: 40vh;
  }
  .v4-main.responsive .login-right {
    flex: none;
    height: 60vh;
  }
}

.login-left {
  flex: 2;
  background: url('ps-background.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  clip-path: polygon(0 0, 100% 0, 50% 100%, 0% 100%);
  background-color: #ffffff;
}

.login-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  position: relative;
  padding: 30px;
  padding-left: 0;
  background-color: #ffffff;
  overflow-y: auto;
  min-width: 572px;
}

app-login,
app-login-v4,
.login-container,
.wrapper {
  margin: auto !important;
  margin-left: 0 !important;
}

.form-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wrapper {
  width: 400px;
  padding: 0 80px;
  text-align: center;
  border-radius: 5px;
  background: #ffffff !important;
  position: relative;
  z-index: 10;
}
.wrapper img {
  width: 75px;
}
.wrapper input {
  width: 100%;
  height: 55px;
  margin-bottom: 20px;
  padding-left: 57.5px;
  font-size: 14px;
  font-family: "asapregular";
  font-weight: normal;
  color: #3d464d;
  background: transparent;
  border: 1px solid #ccd2d5;
  border-radius: 5px;
  outline: none !important;
  text-transform: none !important;
}
.wrapper input:focus {
  border-color: rgb(24, 115, 177);
}
.wrapper input:last-of-type {
  margin-top: 0;
}
.wrapper .logo {
  width: 250px;
  margin-bottom: 30px;
}

.login button,
.btn-primary.btn-block {
  width: 100%;
  height: 55px;
  font-size: 14px;
  font-weight: normal;
  font-family: "asapregular";
  color: #fff;
  background-color: #313541 !important;
  border: none !important;
  border-radius: 5px;
  cursor: pointer;
}
.login button:disabled,
.btn-primary.btn-block:disabled {
  background-color: #bebbbb !important;
}

.input-username,
.input-password {
  position: relative;
}
.input-username:after,
.input-password:after {
  content: "";
  position: absolute;
  top: 16.5px;
  left: 18px;
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
}

.input-username:after {
  background-image: url('icon-username@3x.png');
}

.input-password:after {
  background-image: url('icon-password@3x.png');
}

::placeholder,
::-webkit-input-placeholder,
::-moz-placeholder,
:-ms-input-placeholder,
:-moz-placeholder {
  font-size: 14px;
  font-weight: normal;
  font-family: "asapregular";
  color: #3d464d !important;
}

h1,
h2,
p,
a,
span {
  margin: 0;
  padding: 0;
  font-family: "asapregular";
  color: #313541;
}

h1 {
  font-family: "asapbold";
  font-size: 30px;
  font-weight: normal;
  text-transform: none;
  line-height: normal !important;
  margin-bottom: 30px;
}

h1 span {
  font-family: "asapmedium";
}

.subtitle,
.login-foter p {
  font-size: large;
  font-family: "asapregular";
  margin: 10px 0 40px;
  color: #81898c;
}

.row {
  margin: 0 !important;
}

[class^=col-] {
  padding: 0 !important;
}

.control-wrapper {
  text-align: left;
}

.sided {
  display: inline-table;
  width: 100%;
  height: 30px;
  table-layout: fixed;
}
.sided *,
.sided input {
  vertical-align: middle;
}
.sided input {
  display: none;
}
.sided .sided-child {
  margin-bottom: 10px;
}
.sided label {
  width: 19px;
}
.sided label + span:before {
  content: "";
  position: absolute;
  top: 6px;
  left: 2px;
  width: 14px;
  height: 9px;
  background: url('cb-check.png') center contain no-repeat;
}
.sided p {
  font-size: 14px;
  font-weight: normal;
  font-family: "asapregular";
  color: #81898c;
  padding-left: 12px !important;
  border-color: #ccd2d5;
}

.flex-container {
  display: flex;
}

.jc-space-between {
  justify-content: space-between;
}

.jc-center {
  justify-content: center;
}

.ai-center {
  align-items: center;
}

input[type=checkbox] {
  cursor: pointer;
  accent-color: #313541;
}
input[type=checkbox]:checked {
  accent-color: #313541;
}

a,
label {
  font-size: 14px;
  font-weight: normal;
  font-family: "asapregular";
  color: #81898c;
  text-decoration: none !important;
  cursor: pointer;
}

.options,
.options-centered {
  display: table;
  width: 100%;
}
.options a,
.options-centered a {
  display: table-cell;
}
.options a:first-of-type,
.options-centered a:first-of-type {
  text-align: left;
}
.options a:last-of-type,
.options-centered a:last-of-type {
  text-align: right;
}
.options.options-centered a,
.options-centered.options-centered a {
  text-align: center;
}

.sponsors {
  margin-top: 40px;
  gap: 40px;
}
.sponsors img {
  flex: 1;
  object-fit: contain;
}

.message p {
  font-size: 15px;
  font-weight: normal;
  font-family: "asapregular";
  margin-bottom: 30px;
  color: #d0021b;
}

.unauthorize-message {
  padding: 20px;
  background: #d0021b;
  color: #fff;
  text-align: center;
}

.error-messages p,
.error-p {
  font-size: 14px;
  font-weight: normal;
  font-family: "asapregular";
  color: #e34c4c;
  text-align: left;
  margin: 0;
}

.p-success {
  color: #bed73b !important;
}

.btn-loader {
  position: relative;
  margin: 30px 0;
}
.btn-loader img {
  position: absolute;
  top: 0;
  right: 10px;
  bottom: 0;
  margin: auto;
  width: 30px;
  height: 30px;
}

.loader-wrapper {
  position: absolute;
  top: 165px;
  left: 0;
  right: 0;
}

#clients {
  text-align: center;
  margin: 250px 0 70px;
}
#clients .logo {
  display: inline-block;
  vertical-align: middle;
  height: 252px;
  background: center contain no-repeat;
}

.login-foter {
  display: flex;
  width: 100%;
  background: #f8f8f8;
  padding: 30px 0;
}
.login-foter > div:first-of-type {
  width: 50%;
  padding-left: 120px;
}
.login-foter p,
.login-foter h2 {
  font-size: 15px;
  margin: 10px;
}

.nsm7Bb-HzV7m-LgbsSe {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss","webpack://./../../Projects%20TFS/WebGalis-Core-FE/src/app/components/login/login.component.scss"],"names":[],"mappings":"AAQA;EACI,aAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,yBATkB;ACEtB;ADaQ;EAFJ;IAGQ,sBAAA;ECVV;EDcU;IACI,eAAA;IACA,YAAA;ECZd;EDiBU;IACI,UAAA;IACA,YAAA;ECfd;AACF;;ADsBA;EACI,OAAA;EACA,oCAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,kDAAA;EACA,yBA5CkB;ACyBtB;;ADwBA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBA1DkB;EA2DlB,gBAAA;EACA,gBAAA;ACrBJ;;AD4BA;;;;EAII,uBAAA;EACA,yBAAA;ACzBJ;;AD8BA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AC3BJ;;ADkCA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;AC/BJ;ADmCI;EACI,WAAA;ACjCR;ADsCI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,+BAAA;ACpCR;ADwCQ;EACI,+BAAA;ACtCZ;AD2CQ;EACI,aAAA;ACzCZ;AD+CI;EACI,YAAA;EACA,mBAAA;AC7CR;;ADqDA;;EAEI,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,oCAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AClDJ;ADsDI;;EACI,oCAAA;ACnDR;;AD2DA;;EAEI,kBAAA;ACxDJ;AD4DI;;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;ACzDR;;AD+DI;EACI,6CAAA;AC5DR;;ADiEI;EACI,6CAAA;AC9DR;;ADqEA;;;;;EAKI,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;AClEJ;;ADyEA;;;;;EAKI,SAAA;EACA,UAAA;EACA,0BAAA;EACA,cAnOa;AC6JjB;;AD2EA;EACI,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;ACxEJ;;AD6EI;EACI,yBAAA;AC1ER;;AD+EA;;EAEI,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;AC5EJ;;ADmFA;EACI,oBAAA;AChFJ;;ADqFA;EACI,qBAAA;AClFJ;;ADuFA;EACI,gBAAA;ACpFJ;;ADyFA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACtFJ;AD0FI;;EAEI,sBAAA;ACxFR;AD6FI;EACI,aAAA;AC3FR;ADgGI;EACI,mBAAA;AC9FR;ADmGI;EACI,WAAA;ACjGR;ADqGQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wDAAA;ACnGZ;ADyGI;EACI,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,6BAAA;EACA,qBAAA;ACvGR;;AD6GA;EACI,aAAA;AC1GJ;;AD+GA;EACI,8BAAA;AC5GJ;;ADiHA;EACI,uBAAA;AC9GJ;;ADmHA;EACI,mBAAA;AChHJ;;ADmHA;EACI,eAAA;EACA,qBAxWa;ACwPjB;ADkHI;EACI,qBA3WS;AC2PjB;;ADoHA;;EAEI,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;ACjHJ;;ADwHA;;EAEI,cAAA;EACA,WAAA;ACrHJ;ADyHI;;EACI,mBAAA;ACtHR;AD0HQ;;EACI,gBAAA;ACvHZ;AD4HQ;;EACI,iBAAA;ACzHZ;AD+HI;;EACI,kBAAA;AC5HR;;ADkIA;EACI,gBAAA;EACA,SAAA;AC/HJ;ADmII;EACI,OAAA;EACA,mBAAA;ACjIR;;ADyIA;EACI,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;ACtIJ;;AD2IA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;ACxIJ;;AD6IA;;EAEI,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AC1IJ;;AD+IA;EACI,yBAAA;AC5IJ;;ADmJA;EACI,kBAAA;EACA,cAAA;AChJJ;ADoJI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AClJR;;ADwJA;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;ACrJJ;;AD4JA;EACI,kBAAA;EACA,oBAAA;ACzJJ;AD6JI;EACI,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,oCAAA;AC3JR;;ADmKA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AChKJ;ADoKI;EACI,UAAA;EACA,mBAAA;AClKR;ADuKI;;EAEI,eAAA;EACA,YAAA;ACrKR;;ADyKA;EACI,sBAAA;ACtKJ","sourcesContent":["// Variables\r\n\r\n$highlightColor: #313541;\r\n\r\n$pageBackgroundColor: #ffffff;\r\n\r\n// Layout\r\n\r\n.v4-main {\r\n    display: flex;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    overflow: hidden;\r\n    background-color: $pageBackgroundColor;\r\n\r\n\r\n\r\n    &.responsive {\r\n\r\n        @media (max-width: 768px) {\r\n            flex-direction: column;\r\n\r\n\r\n\r\n            .login-left {\r\n                clip-path: none;\r\n                height: 40vh;\r\n            }\r\n\r\n\r\n\r\n            .login-right {\r\n                flex: none;\r\n                height: 60vh;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n.login-left {\r\n    flex: 2;\r\n    background: url('../../../assets/project-custom/images/ps-background.png');\r\n    background-position: center;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    clip-path: polygon(0 0, 100% 0, 50% 100%, 0% 100%);\r\n    background-color: $pageBackgroundColor;\r\n}\r\n\r\n\r\n\r\n.login-right {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: start;\r\n    align-items: center;\r\n    position: relative;\r\n    padding: 30px;\r\n    padding-left: 0;\r\n    background-color: $pageBackgroundColor;\r\n    overflow-y: auto;\r\n    min-width: 572px;\r\n}\r\n\r\n\r\n\r\n// Common resets\r\n\r\napp-login,\r\napp-login-v4,\r\n.login-container,\r\n.wrapper {\r\n    margin: auto !important;\r\n    margin-left: 0 !important;\r\n}\r\n\r\n\r\n\r\n.form-checkbox {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n\r\n\r\n// Wrapper\r\n\r\n.wrapper {\r\n    width: 400px;\r\n    padding: 0 80px;\r\n    text-align: center;\r\n    border-radius: 5px;\r\n    background: $pageBackgroundColor !important;\r\n    position: relative;\r\n    z-index: 10;\r\n\r\n\r\n\r\n    img {\r\n        width: 75px;\r\n    }\r\n\r\n\r\n\r\n    input {\r\n        width: 100%;\r\n        height: 55px;\r\n        margin-bottom: 20px;\r\n        padding-left: 57.5px;\r\n        font-size: 14px;\r\n        font-family: \"asapregular\";\r\n        font-weight: normal;\r\n        color: #3d464d;\r\n        background: transparent;\r\n        border: 1px solid #ccd2d5;\r\n        border-radius: 5px;\r\n        outline: none !important;\r\n        text-transform: none !important;\r\n\r\n\r\n\r\n        &:focus {\r\n            border-color: rgb(24, 115, 177);\r\n        }\r\n\r\n\r\n\r\n        &:last-of-type {\r\n            margin-top: 0;\r\n        }\r\n    }\r\n\r\n\r\n\r\n    .logo {\r\n        width: 250px;\r\n        margin-bottom: 30px;\r\n    }\r\n}\r\n\r\n\r\n\r\n// Buttons\r\n\r\n.login button,\r\n.btn-primary.btn-block {\r\n    width: 100%;\r\n    height: 55px;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-family: \"asapregular\";\r\n    color: #fff;\r\n    background-color: $highlightColor !important;\r\n    border: none !important;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n\r\n\r\n\r\n    &:disabled {\r\n        background-color: #bebbbb !important;\r\n    }\r\n}\r\n\r\n\r\n\r\n// Input icons\r\n\r\n.input-username,\r\n.input-password {\r\n    position: relative;\r\n\r\n\r\n\r\n    &:after {\r\n        content: '';\r\n        position: absolute;\r\n        top: 16.5px;\r\n        left: 18px;\r\n        width: 22px;\r\n        height: 23px;\r\n        background-repeat: no-repeat;\r\n        background-size: contain;\r\n    }\r\n}\r\n\r\n\r\n\r\n    .input-username:after {\r\n        background-image: url('../../../assets/css/images/platform/icon-username@3x.png');\r\n    }\r\n\r\n\r\n\r\n    .input-password:after {\r\n        background-image: url('../../../assets/css/images/platform/icon-password@3x.png');\r\n    }\r\n\r\n\r\n\r\n// Placeholder styling\r\n\r\n::placeholder,\r\n::-webkit-input-placeholder,\r\n::-moz-placeholder,\r\n:-ms-input-placeholder,\r\n:-moz-placeholder {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-family: \"asapregular\";\r\n    color: #3d464d !important;\r\n}\r\n\r\n\r\n\r\n// Text elements\r\n\r\nh1,\r\nh2,\r\np,\r\na,\r\nspan {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: \"asapregular\";\r\n    color: $highlightColor;\r\n}\r\n\r\n\r\n\r\nh1 {\r\n    font-family: \"asapbold\";\r\n    font-size: 30px;\r\n    font-weight: normal;\r\n    text-transform: none;\r\n    line-height: normal !important;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n\r\n\r\n    h1 span {\r\n        font-family: \"asapmedium\";\r\n    }\r\n\r\n\r\n\r\n.subtitle,\r\n.login-foter p {\r\n    font-size: large;\r\n    font-family: \"asapregular\";\r\n    margin: 10px 0 40px;\r\n    color: #81898c;\r\n}\r\n\r\n\r\n\r\n// Utility\r\n\r\n.row {\r\n    margin: 0 !important;\r\n}\r\n\r\n\r\n\r\n[ class^=\"col-\"] {\r\n    padding: 0 !important;\r\n}\r\n\r\n\r\n\r\n.control-wrapper {\r\n    text-align: left;\r\n}\r\n\r\n\r\n\r\n.sided {\r\n    display: inline-table;\r\n    width: 100%;\r\n    height: 30px;\r\n    table-layout: fixed;\r\n\r\n\r\n\r\n    *,\r\n    input {\r\n        vertical-align: middle;\r\n    }\r\n\r\n\r\n\r\n    input {\r\n        display: none;\r\n    }\r\n\r\n\r\n\r\n    .sided-child {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n\r\n\r\n    label {\r\n        width: 19px;\r\n\r\n\r\n\r\n        + span:before {\r\n            content: '';\r\n            position: absolute;\r\n            top: 6px;\r\n            left: 2px;\r\n            width: 14px;\r\n            height: 9px;\r\n            background: url('../../../assets/css/images/platform/cb-check.png') center contain no-repeat;\r\n        }\r\n    }\r\n\r\n\r\n\r\n    p {\r\n        font-size: 14px;\r\n        font-weight: normal;\r\n        font-family: \"asapregular\";\r\n        color: #81898c;\r\n        padding-left: 12px !important;\r\n        border-color: #ccd2d5;\r\n    }\r\n}\r\n\r\n\r\n\r\n.flex-container {\r\n    display: flex;\r\n}\r\n\r\n\r\n\r\n.jc-space-between {\r\n    justify-content: space-between;\r\n}\r\n\r\n\r\n\r\n.jc-center {\r\n    justify-content: center;\r\n}\r\n\r\n\r\n\r\n.ai-center {\r\n    align-items: center;\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n    cursor: pointer;\r\n    accent-color: $highlightColor;\r\n\r\n    &:checked {\r\n        accent-color: $highlightColor;\r\n    }\r\n}\r\n\r\na,\r\nlabel {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-family: \"asapregular\";\r\n    color: #81898c;\r\n    text-decoration: none !important;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.options,\r\n.options-centered {\r\n    display: table;\r\n    width: 100%;\r\n\r\n\r\n\r\n    a {\r\n        display: table-cell;\r\n\r\n\r\n\r\n        &:first-of-type {\r\n            text-align: left;\r\n        }\r\n\r\n\r\n\r\n        &:last-of-type {\r\n            text-align: right;\r\n        }\r\n    }\r\n\r\n\r\n\r\n    &.options-centered a {\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n\r\n\r\n.sponsors {\r\n    margin-top: 40px;\r\n    gap: 40px;\r\n\r\n\r\n\r\n    img {\r\n        flex: 1;\r\n        object-fit: contain;\r\n    }\r\n}\r\n\r\n\r\n\r\n// Messages & alerts\r\n\r\n.message p {\r\n    font-size: 15px;\r\n    font-weight: normal;\r\n    font-family: \"asapregular\";\r\n    margin-bottom: 30px;\r\n    color: #d0021b;\r\n}\r\n\r\n\r\n\r\n.unauthorize-message {\r\n    padding: 20px;\r\n    background: #d0021b;\r\n    color: #fff;\r\n    text-align: center;\r\n}\r\n\r\n\r\n\r\n.error-messages p,\r\n.error-p {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-family: \"asapregular\";\r\n    color: #e34c4c;\r\n    text-align: left;\r\n    margin: 0;\r\n}\r\n\r\n\r\n\r\n.p-success {\r\n    color: #bed73b !important;\r\n}\r\n\r\n\r\n\r\n// Loader\r\n\r\n.btn-loader {\r\n    position: relative;\r\n    margin: 30px 0;\r\n\r\n\r\n\r\n    img {\r\n        position: absolute;\r\n        top: 0;\r\n        right: 10px;\r\n        bottom: 0;\r\n        margin: auto;\r\n        width: 30px;\r\n        height: 30px;\r\n    }\r\n}\r\n\r\n\r\n\r\n.loader-wrapper {\r\n    position: absolute;\r\n    top: 165px;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\n\r\n\r\n// Client logos\r\n\r\n#clients {\r\n    text-align: center;\r\n    margin: 250px 0 70px;\r\n\r\n\r\n\r\n    .logo {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        height: 252px;\r\n        background: center contain no-repeat;\r\n    }\r\n}\r\n\r\n\r\n\r\n// Footer\r\n\r\n.login-foter {\r\n    display: flex;\r\n    width: 100%;\r\n    background: #f8f8f8;\r\n    padding: 30px 0;\r\n\r\n\r\n\r\n    > div:first-of-type {\r\n        width: 50%;\r\n        padding-left: 120px;\r\n    }\r\n\r\n\r\n\r\n    p,\r\n    h2 {\r\n        font-size: 15px;\r\n        margin: 10px;\r\n    }\r\n}\r\n\r\n.nsm7Bb-HzV7m-LgbsSe {\r\n    width: 100% !important;\r\n}\r\n",".v4-main {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  background-color: #ffffff;\n}\n@media (max-width: 768px) {\n  .v4-main.responsive {\n    flex-direction: column;\n  }\n  .v4-main.responsive .login-left {\n    clip-path: none;\n    height: 40vh;\n  }\n  .v4-main.responsive .login-right {\n    flex: none;\n    height: 60vh;\n  }\n}\n\n.login-left {\n  flex: 2;\n  background: url(\"../../../assets/project-custom/images/ps-background.png\");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  clip-path: polygon(0 0, 100% 0, 50% 100%, 0% 100%);\n  background-color: #ffffff;\n}\n\n.login-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n  position: relative;\n  padding: 30px;\n  padding-left: 0;\n  background-color: #ffffff;\n  overflow-y: auto;\n  min-width: 572px;\n}\n\napp-login,\napp-login-v4,\n.login-container,\n.wrapper {\n  margin: auto !important;\n  margin-left: 0 !important;\n}\n\n.form-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.wrapper {\n  width: 400px;\n  padding: 0 80px;\n  text-align: center;\n  border-radius: 5px;\n  background: #ffffff !important;\n  position: relative;\n  z-index: 10;\n}\n.wrapper img {\n  width: 75px;\n}\n.wrapper input {\n  width: 100%;\n  height: 55px;\n  margin-bottom: 20px;\n  padding-left: 57.5px;\n  font-size: 14px;\n  font-family: \"asapregular\";\n  font-weight: normal;\n  color: #3d464d;\n  background: transparent;\n  border: 1px solid #ccd2d5;\n  border-radius: 5px;\n  outline: none !important;\n  text-transform: none !important;\n}\n.wrapper input:focus {\n  border-color: rgb(24, 115, 177);\n}\n.wrapper input:last-of-type {\n  margin-top: 0;\n}\n.wrapper .logo {\n  width: 250px;\n  margin-bottom: 30px;\n}\n\n.login button,\n.btn-primary.btn-block {\n  width: 100%;\n  height: 55px;\n  font-size: 14px;\n  font-weight: normal;\n  font-family: \"asapregular\";\n  color: #fff;\n  background-color: #313541 !important;\n  border: none !important;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.login button:disabled,\n.btn-primary.btn-block:disabled {\n  background-color: #bebbbb !important;\n}\n\n.input-username,\n.input-password {\n  position: relative;\n}\n.input-username:after,\n.input-password:after {\n  content: \"\";\n  position: absolute;\n  top: 16.5px;\n  left: 18px;\n  width: 22px;\n  height: 23px;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.input-username:after {\n  background-image: url(\"../../../assets/css/images/platform/icon-username@3x.png\");\n}\n\n.input-password:after {\n  background-image: url(\"../../../assets/css/images/platform/icon-password@3x.png\");\n}\n\n::placeholder,\n::-webkit-input-placeholder,\n::-moz-placeholder,\n:-ms-input-placeholder,\n:-moz-placeholder {\n  font-size: 14px;\n  font-weight: normal;\n  font-family: \"asapregular\";\n  color: #3d464d !important;\n}\n\nh1,\nh2,\np,\na,\nspan {\n  margin: 0;\n  padding: 0;\n  font-family: \"asapregular\";\n  color: #313541;\n}\n\nh1 {\n  font-family: \"asapbold\";\n  font-size: 30px;\n  font-weight: normal;\n  text-transform: none;\n  line-height: normal !important;\n  margin-bottom: 30px;\n}\n\nh1 span {\n  font-family: \"asapmedium\";\n}\n\n.subtitle,\n.login-foter p {\n  font-size: large;\n  font-family: \"asapregular\";\n  margin: 10px 0 40px;\n  color: #81898c;\n}\n\n.row {\n  margin: 0 !important;\n}\n\n[class^=col-] {\n  padding: 0 !important;\n}\n\n.control-wrapper {\n  text-align: left;\n}\n\n.sided {\n  display: inline-table;\n  width: 100%;\n  height: 30px;\n  table-layout: fixed;\n}\n.sided *,\n.sided input {\n  vertical-align: middle;\n}\n.sided input {\n  display: none;\n}\n.sided .sided-child {\n  margin-bottom: 10px;\n}\n.sided label {\n  width: 19px;\n}\n.sided label + span:before {\n  content: \"\";\n  position: absolute;\n  top: 6px;\n  left: 2px;\n  width: 14px;\n  height: 9px;\n  background: url(\"../../../assets/css/images/platform/cb-check.png\") center contain no-repeat;\n}\n.sided p {\n  font-size: 14px;\n  font-weight: normal;\n  font-family: \"asapregular\";\n  color: #81898c;\n  padding-left: 12px !important;\n  border-color: #ccd2d5;\n}\n\n.flex-container {\n  display: flex;\n}\n\n.jc-space-between {\n  justify-content: space-between;\n}\n\n.jc-center {\n  justify-content: center;\n}\n\n.ai-center {\n  align-items: center;\n}\n\ninput[type=checkbox] {\n  cursor: pointer;\n  accent-color: #313541;\n}\ninput[type=checkbox]:checked {\n  accent-color: #313541;\n}\n\na,\nlabel {\n  font-size: 14px;\n  font-weight: normal;\n  font-family: \"asapregular\";\n  color: #81898c;\n  text-decoration: none !important;\n  cursor: pointer;\n}\n\n.options,\n.options-centered {\n  display: table;\n  width: 100%;\n}\n.options a,\n.options-centered a {\n  display: table-cell;\n}\n.options a:first-of-type,\n.options-centered a:first-of-type {\n  text-align: left;\n}\n.options a:last-of-type,\n.options-centered a:last-of-type {\n  text-align: right;\n}\n.options.options-centered a,\n.options-centered.options-centered a {\n  text-align: center;\n}\n\n.sponsors {\n  margin-top: 40px;\n  gap: 40px;\n}\n.sponsors img {\n  flex: 1;\n  object-fit: contain;\n}\n\n.message p {\n  font-size: 15px;\n  font-weight: normal;\n  font-family: \"asapregular\";\n  margin-bottom: 30px;\n  color: #d0021b;\n}\n\n.unauthorize-message {\n  padding: 20px;\n  background: #d0021b;\n  color: #fff;\n  text-align: center;\n}\n\n.error-messages p,\n.error-p {\n  font-size: 14px;\n  font-weight: normal;\n  font-family: \"asapregular\";\n  color: #e34c4c;\n  text-align: left;\n  margin: 0;\n}\n\n.p-success {\n  color: #bed73b !important;\n}\n\n.btn-loader {\n  position: relative;\n  margin: 30px 0;\n}\n.btn-loader img {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  bottom: 0;\n  margin: auto;\n  width: 30px;\n  height: 30px;\n}\n\n.loader-wrapper {\n  position: absolute;\n  top: 165px;\n  left: 0;\n  right: 0;\n}\n\n#clients {\n  text-align: center;\n  margin: 250px 0 70px;\n}\n#clients .logo {\n  display: inline-block;\n  vertical-align: middle;\n  height: 252px;\n  background: center contain no-repeat;\n}\n\n.login-foter {\n  display: flex;\n  width: 100%;\n  background: #f8f8f8;\n  padding: 30px 0;\n}\n.login-foter > div:first-of-type {\n  width: 50%;\n  padding-left: 120px;\n}\n.login-foter p,\n.login-foter h2 {\n  font-size: 15px;\n  margin: 10px;\n}\n\n.nsm7Bb-HzV7m-LgbsSe {\n  width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
